<template>
  <div class="fair-user-component">
    <!-- <nuxt-link
      v-for="user in data"
      :key="user.id"
      :to="`/expouser/${user.uid}.html`"
      :title="`${user.nickName || user.userName}用户中心`"
      target="_blank"
    > -->
    <div
      v-for="user in data"
      :key="user.id">
      <div
        class="user-item"
        @click="toUser(user.uid)">
        <div class="avatar-box">
          <img
            :src="user.avatar ? user.avatar + getXOssProcess({ w: 36, h: 36 }) : HeadImg"
            alt="头像"
            rel="nofollow,noindex"
            loading="lazy" />
          <!-- <Avatar v-else :text="user.nickName || user.userName" /> -->
        </div>
        <div class="user-name">{{ user.companyName }}</div>
        <div class="user-company-name">
          {{ user.nickName || user.userName }}
        </div>
        <div class="view-btn">{{ $t('common.view') }}</div>
      </div>
    </div>
    <!-- </nuxt-link> -->
    <el-dialog
      destroy-on-close
      width="400px"
      class="join-dialog"
      title="完善信息查看用户社区"
      :visible.sync="userVisible"
      :before-close="resetForm"
      :close-on-click-modal="false"
      :close-on-press-escape="false">
      <div class="box">
        <el-form
          ref="formRef"
          :model="ruleForm"
          :rules="rules">
          <el-form-item prop="companyName">
            <el-input
              v-model="ruleForm.companyName"
              clearable
              placeholder="请输入公司名称(必填)"
              style="width: 350px"></el-input>
          </el-form-item>
          <el-form-item>
            <el-input
              v-model="ruleForm.companyOfficialWebsite"
              clearable
              placeholder="请输入公司官网(选填)"
              style="width: 350px"></el-input>
          </el-form-item>
          <el-form-item
            prop="productNames"
            v-for="(item, index) in ruleForm.productNames"
            :key="index">
            <div class="fair-input">
              <el-input
                v-model="item.value"
                placeholder="请输入公司产品（必填）"
                style="width: 320px"
                clearable></el-input>
              <i
                class="el-icon-circle-plus-outline"
                @click="addDomain"></i>
              <i
                v-if="ruleForm.productNames.length > 1"
                class="el-icon-remove-outline"
                @click.prevent="removeDomain(index)"></i>
            </div>
          </el-form-item>

          <el-form-item class="_fun-hide">
            <el-input
              v-model="ruleForm.email"
              clearable
              placeholder="请输入邮箱(选填)"
              style="width: 350px"></el-input>
          </el-form-item>
        </el-form>
      </div>

      <span
        slot="footer"
        class="dialog-footer">
        <el-button @click="resetForm(formRef)">取 消</el-button>
        <el-button
          type="primary"
          @click="submit(formRef)">
          确 定
        </el-button>
      </span>
    </el-dialog>
  </div>
</template>

<script lang="ts" setup>
  import { defineProps, ref } from 'vue'
  import { type FormInstance } from 'element-plus'
  import _ from 'lodash'
  import { getXOssProcess } from '~/utils/common'
  import HeadImg from 'assets/images/headimg.jpg'
  import { fetchCheckFollowUserInfo, fetchUpdateFollowUserInfo } from '~/api/followeApi'
  import type Login from '~/components/Login/index.vue'

  // const Avatar = defineAsyncComponent(() => import('~/components/Avatar/index.vue'));
  const props = defineProps({
    data: {
      default: (): Record<string, any> => []
    }
  })

  const loginModal = inject('loginModal') as Ref<InstanceType<typeof Login>>
  const tokenCookie = useCookie('access_token', {
    maxAge: 60 * 60 * 24 * 7,
    domain: 'jufair.com'
  })

  const formRef = ref<FormInstance | null>(null)
  const userVisible = ref(false)
  const ruleForm = ref({
    companyName: '',
    companyOfficialWebsite: '',
    email: '',
    productNames: [{ value: '' }]
  })
  const rules = {
    companyName: [{ required: true, message: '公司名称不能为空', trigger: 'blur' }],
    productNames: [{ required: true, message: '公司产品不能为空', trigger: 'blur' }]
  }
  const userId = ref(0)

  const toUser = async (id: number) => {
    if (shouldLogin()) {
      userId.value = id
      const res = await fetchCheckFollowUserInfo()
      if (res?.code === '16002') {
        userVisible.value = true
      } else {
        window.open(`/expouser/${id}.html`)
      }
    }
  }

  const addDomain = () => {
    ruleForm.value.productNames.push({
      value: ''
    })
  }

  const removeDomain = (idx: number) => {
    ruleForm.value.productNames.splice(idx, 1)
  }

  const resetForm = (formEl: FormInstance | null) => {
    formEl?.resetFields()
    userVisible.value = false
  }

  const shouldLogin = () => {
    if (!tokenCookie.value) {
      loginModal.value.open()
    }
    return !!tokenCookie.value
  }

  const submit = (formEl: FormInstance | null) => {
    formEl?.validate(valid => {
      if (valid) {
        fecthSave()
      }
    })
  }

  const fecthSave = async () => {
    ruleForm.value.productNames = _.cloneDeep(
      ruleForm.value.productNames.map((item: any) => item.value)
    )
    const res: any = await fetchUpdateFollowUserInfo({
      ...ruleForm.value
    })
    if (res.code === '1') {
      formRef.value?.resetFields()
      resetForm(formRef.value)
      setTimeout(() => {
        window.open(`/expouser/${userId.value}.html`)
      }, 1000)
    }
  }
</script>

<style lang="less" scoped>
  .fair-user-component {
    display: flex;
    flex-wrap: wrap;
    gap: 9px;

    .user-item {
      padding: 10px;
      width: 125px;
      height: 143px;
      border: 1px solid #f0f0f0;
      border-radius: 4px;
      box-sizing: border-box;
      display: flex;
      flex-direction: column;
      align-items: center;
      gap: 8px 0;
      cursor: pointer;
      background: #fff;

      &:hover {
        .user-name,
        .user-company-name {
          color: #666;
        }

        .view-btn {
          border: 1px solid @app-color;
          background: @app-color;
          color: #fff;
        }
      }

      .user-name,
      .user-company-name {
        text-overflow: ellipsis;
        white-space: nowrap;
        overflow: hidden;
        font-size: 14px;
        color: #333;
        width: 100%;
        text-align: center;
      }

      .avatar-box {
        display: flex;
        height: 36px;
        justify-content: center;
        align-items: center;
        border-radius: 50%;
        transform: translateZ(0);
        overflow: hidden;

        img {
          width: 36px; /* 图片宽度填满容器 */
          height: 36px; /* 图片高度填满容器 */
          object-fit: cover; /* 不变形填充 */
        }
      }

      .view-btn {
        font-size: 13px;
        border-radius: 2px;
        padding: 6px 0;
        width: 100%;
        border: 1px solid #e9e9e9;
        text-align: center;
        box-sizing: border-box;
        color: #333;
        transition: all 0.3s;
        margin-top: auto;
      }
    }
  }
</style>
